// extracted by mini-css-extract-plugin
export var chevronIcon = "_9s-2";
export var teamName = "_9s-1";
export var teamSwitcherButton = "_9s-0";